module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/bartender-6e54aa764fb422315321c3799315921d.webp";